<!-- 目标查看 -->
<template>
    <TargetSigned :getData="getData" :kindType="getData.kindType" :kindTypeName="getData.kindTypeName">
        <template #top>
          <h-list-page class="target_setting_style">
            <div class="targetSigned_title_left_style">{{ h_i18n('9e5ffa068ed435ced73dc9bf5dd8e09c') }}</div>
            <h-card title="" width="100%" is-open @change-method="changeMethod">
              <el-row class="target_top_row1">
                <el-col :span="6">
                  <span class="target_top_left">{{ h_i18n('1253c30c3f9dc79e8a0d378c82e502b7') }}</span>
                  <span class="target_top_right">{{ getData.sqeNode }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="target_top_left">{{ h_i18n('5419bedbbe015e4bcfb4d002cd6e30eb') }}</span>
                  <span class="target_top_right">{{ getData.ecosphere }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="target_top_left">{{ h_i18n('15be0cbf984ead7733f52bbd01db11a2') }}</span>
                  <span class="target_top_right">{{ getData.supplyCode }}</span>
                </el-col>
                <el-col :span="6">
                  <span class="target_top_left">{{ h_i18n('eb0e130294c8c3b3fa2cfecc849fec49') }}</span>
                  <span class="target_top_right">{{ getData.supplyName }}</span>
                </el-col>
              </el-row>
              <el-row class="target_top_row2">
                <el-col :span="6">
                  <span class="target_top_left">{{ h_i18n('0d69b46438697d065a597136362208cc') }}</span>
                  <span class="target_top_right">{{ getData.year }}</span>
                </el-col>
                <!-- <el-col :span="6">
                  <span class="target_top_left">
                  发起人：
                </span>
                  <span class="target_top_right">{{ getData.createName }}</span>
                </el-col> -->
                <el-col :span="6">
                  <span class="target_top_left">{{ h_i18n('97cddb8e241be64dc25fd7588bd33f01') }}</span>
                  <span class="target_top_right">{{ time(getData.createTime,6) }}</span>
                </el-col>
                <el-col :span="6">
                <span class="target_top_left">{{ h_i18n('f81966c05e27c26bd2484ab49c1345b0') }}</span>
                <span class="target_top_right">{{ getData.goalCode }}</span>
              </el-col>
              </el-row>
            </h-card>
          </h-list-page>
        </template>
      </TargetSigned>
      <div class="target_bottom_style" >
      <div class="target_bottom_inner_style">
        <div class="target_bottom_inner_title_style">
          <span class="targetSigned_left_style">{{ h_i18n('1b04338f38832c8fc906eca58cee865f') }}</span>
        </div>
        <div class="targetSigned_body_style">{{ h_i18n('4cfbf660bad32ab126f722e77148ca6c') }}</div>
        <div class="targetSigned_body_style">
          <div class="targetSigned_body_row_style">
            <div>{{ h_i18n('dfd812d92cd2d9d939e0eab104784f31') }}</div>
            <div class="targetSigned_body_right_style">
              <!-- <el-select v-model="postData.signMessage"> -->
              <el-select v-model="postData.signMessage">
                <el-option value="P" :label="h_i18n('e61f2cc4c39244f627b20e18788c3890')"></el-option>
                <el-option value="F" :label="h_i18n('5ac2011aeb75fda311b7c73dcf2f78d4')"></el-option>
              </el-select>
            </div>
          </div>
          <div class="targetSigned_body_row_style">
            <div>{{ h_i18n('46586accdc521c9945f86bf1f753bf5b') }}</div>
            <div style="margin-left: 23px;" class="targetSigned_body_right_style">
              <el-input :rows="3" type="textarea" v-model="postData.reason" maxlength="500"></el-input>
            </div>
          </div>
          <div class="targetSigned_body_row_style">
            <div>{{ h_i18n('df713dfbe610b926ac70234219f1230b') }}</div>
            <div class="targetSigned_body_right_style">
              <el-input v-model="postData.affirmDate" disabled></el-input>
            </div>
          </div>
          <div class="targetSigned_body_row_style">
            <div>{{ h_i18n('ed46275c53ea4897d4a6f89e3d6706e1') }}</div>
            <div class="targetSigned_body_right_style">
              <hc-file-upload download delete v-model="data.fileTemp" accept="all" :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')"
                @error="errorFile" @delete="deleteFun()" @download="download()" @change="fileChange">
              </hc-file-upload>
              <!-- <hc-file-upload :name="getData.signFileName" :delete-type="false" :url="getData.signFileUuid"></hc-file-upload> -->
            </div>
          </div>
        </div>
        <h-button-group align="center" style="padding-bottom: 20px;">
          <h-button type="primary" @click="subBtn" :loading="data.btnLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <h-button type="default" @click="backBtn">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </div>
    </template>
    
    
  
    
    
    
        
  <script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

    import {reactive,getCurrentInstance,onMounted,ref,nextTick,onActivated,onDeactivated,} from "vue";
    import { useRoute } from "vue-router";
    import TargetSigned from "../TargetSigned"
    const { proxy, ctx } = getCurrentInstance();
    const route = useRoute();
    const getData = reactive({
      supplyCode: "",
      getDataList:[],
      kindType:'target',
      kindTypeName:h_i18n('7b5de7bdb259d9d61753193de5049dc6'),
    });
    const data = reactive({
      tableLoading:false,
      fileTemp:{},
      btnLoading:false,
    })
    const getGoalOneData = reactive({})
    const postData = reactive({
  
    })
    const searchTemp = reactive({})
    /**
     * 传高度
     */
    const changeMethod = () => {
      proxy.postThisPageHeight();
    };
  
    const getInfo = () => {
      proxy.$http({
        url:'/base/ecosphere/getGoalOne',
        method: 'post',
        params:{
          id:data.id,
          name: data.supplyCode,
          nickName: data.supplyName,
        }
      })
      .then((res) => {
        if(res.data.code === '200'){
          let resData = res.data.data
          for (const key in res.data.data) {
            getGoalOneData[key] = res.data.data[key]
          }
          getData.sqeNode = resData.sqeNode
          getData.ecosphere = resData.ecosphere
          getData.supplyCode = resData.supplyCode
          getData.supplyName = resData.supplyName
          getData.year = resData.year
          getData.goalCode = resData.goalCode
          getData.createName = resData.createName
          getData.id = resData.id
          getData.createTime = resData.createTime
  
  
          setSaveInfo(resData)
        }else{
        }
      })
      .catch((err) => {
      })
      .finally(() => {
      });
    }
  
    // 反写数据
    const setSaveInfo = (resData) => {
      let monthList =  ['year','jan','feb','mar','apr','may','jun','jul','aug','sept','oct','nov','dec']
      let middleText = ['TargetGoal','TargetAmount','ImproveGoal','ImproveAmount', // 前四个相同
        'SameLoss', // 同期损失
        'SameAmount' // 同期数量
      ]
      // loss 损失
      // reject 不良
      let rightText = ['Year','January','February','March','April','May','June','July','August','September','October','November','December']
      let tableLossTargetLabel = [{},{},{},{},{}]
      let tableBadQuantityTargetLabel = [{},{},{},{},{}]
      for(let i = 0; i < middleText.length ; i++){
        rightText.forEach((item,index) =>{
          if(i == 4){
            // 同期损失
            tableLossTargetLabel[i][monthList[index]] = Number(resData[`loss${middleText[i]}${item}`])
          }else if(i == 5){
            // 同期数量
            tableBadQuantityTargetLabel[4][monthList[index]] = Number(resData[`reject${middleText[i]}${item}`])
          }else if(i == 0 || i == 2){
            tableLossTargetLabel[i][monthList[index]] = Number(resData[`loss${middleText[i]}${item}`]).toFixed(2)
            tableBadQuantityTargetLabel[i][monthList[index]] = Number(resData[`reject${middleText[i]}${item}`]).toFixed(2)
          } else {
            tableLossTargetLabel[i][monthList[index]] = Number(resData[`loss${middleText[i]}${item}`]) ? Number(resData[`loss${middleText[i]}${item}`]).toFixed(2) : 0
            tableBadQuantityTargetLabel[i][monthList[index]] = Number(resData[`reject${middleText[i]}${item}`])
          }
        })
      }
      tableLossTargetLabel[0].project = h_i18n('a754dabb451b1668009037edfa109947')
      tableLossTargetLabel[1].project = h_i18n('0c78770ef512ea10e23f94be726e7c11')
      tableLossTargetLabel[2].project = h_i18n('3f3e62729afacaa955a69eb8615465c5')
      tableLossTargetLabel[3].project = h_i18n('ee2c1d22266d99192d3912036a146c85')
      tableLossTargetLabel[4].project = h_i18n('e8fb4ee474957b4c13ac146e38bd3c82')
  
      tableBadQuantityTargetLabel[0].project = h_i18n('a754dabb451b1668009037edfa109947')
      tableBadQuantityTargetLabel[1].project = h_i18n('820abf165feb46635ef787b2ead0b725')
      tableBadQuantityTargetLabel[2].project = h_i18n('3f3e62729afacaa955a69eb8615465c5')
      tableBadQuantityTargetLabel[3].project = h_i18n('1bfc8e8c4777c05b86a15254af33c859')
      tableBadQuantityTargetLabel[4].project = h_i18n('6598c547fe31e5f5891d4ea679218444')
  
      getData.tableLossTargetLabel = tableLossTargetLabel
      getData.tableBadQuantityTargetLabel = tableBadQuantityTargetLabel
    }
    // 返回
    const backBtn = () => {
      proxy.$router.back();
    }
    // 提交
    const subBtn = () => {
      if(!postData.signMessage){
        proxy.info(h_i18n('1302e200a2eb5c67ae22c1b511708a7c'))
        return
      }
      if(!postData.reason){
        proxy.info(h_i18n('84dfdc6be1127b0fc6c5fb19c785611a'))
        return
      }
      if(!postData.affirmDate){
        proxy.info(h_i18n('7cef8706dc1bce8a4aa8cb8599baf624'))
        return
      }
      if(!postData.signFileUuid || !postData.signFileName){
        proxy.info(h_i18n('d267c2e1e843a60995f11d0083f3a79f'))
        return
      }
      console.log(postData)
      data.btnLoading = true
      proxy.$http({
        method:'post',
        url:'/base/ecosphere/supplySign',
        data:{
          ...getGoalOneData,
          ...getData,
          ...postData,
          supplyCode:data.supplyCode,
          supplyName:data.supplyName,
          trueName:data.trueName,
          affirmDate:undefined,
          tableBadQuantityTargetLabel:undefined,
          tableLossTargetLabel:undefined,
          goalStatus:postData.signMessage == 'P' ? 2393 : 2394,
          name: data.supplyCode,
          nickName: data.supplyName,
        }
      }).then(res=>{
        if(res.data.code === '200'){
          proxy.success({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message: res.data.data || h_i18n('fc74015d767b3889e68982b809980a55'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
                proxy.$router.back();
              },
            }
          )
        }else{
          proxy.info(res.data.data)
        }
      }).catch(err=>{

      }).finally(()=>[
        data.btnLoading = false
      ])
    }
    /**
   * h-file-upload 删除
   */
  const deleteFun = () =>{
    if(postData.signFileUuid){
      postData.signFileUuid = ''
      postData.signFileName = ''
    }else{
      proxy.warning(h_i18n('80651925d5045d6d7459a21045e1d93f'))
    }
  }
  /**
   * h-file-upload 上传文件
   */
   const fileChange = (file) => {
    // console.log(file.name)
      let formData = new FormData()
      formData.append('files', file.file)
      proxy.$http({
        method: "POST",
        url: "/base/fileUpload/uploadToOssSaveUrl",
        data: formData
      }).then(res => {
        if (res.data.code === "0") {
          postData.signFileName = file.name 
          postData.signFileUuid = res.data.data
        } else {
          proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
          data.fileOfOther = null
        }
      })
  }
  /**
   * h-file-upload 下载
   */
   const download = () =>{
    if(postData.signFileUuid){
      let uid = ''
      if(!postData.signFileUuid.includes("http")){
        uid = '/base/fileDownload/downloadFile?filePath='+postData.signFileUuid
      }else{
        uid = "/base/fileDownload/downloadFile?filePath="+postData.signFileUuid.split('https://sqm.haier.net/readFile/')[1]
      }
      proxy.startLoading(h_i18n('29f986479f7cf1f93d31172f343d4521'))
      proxy.httpFile({
        method: "get",
        url: uid,
        headers: {'content-type': 'application/json'},
      }, postData.signFileName)
    }else{
      proxy.warning(h_i18n('80651925d5045d6d7459a21045e1d93f'))
    }
  }
    const errorFile = (str) => {
      proxy.warning({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: str})
    }
    onMounted(()=>{
      if (route.query) {
        data.supplyCode = route.query.supplyCode;
        data.supplyName = route.query.supplyName;
        data.trueName = route.query.trueName
        data.userName =  route.query.userName
        // if(!route.query.name){
        //   proxy.info({title: '提示', message: '请先登录或重新登录后再试',confirmButtonText: "确定",
        //     callback: (action) => {
        //       proxy.$router.back()
        //     },})
        //   return
        // }
      }
      postData.affirmDate = proxy.time(new Date(),6)
      data.id = route.query.id
      // if(route.query.dataFrom != 'hmqm'){
      //   proxy.$router.replace('/404')
      //   return
      // }
      getInfo()
    })
    </script>

<style lang="scss">
    .target_setting_style {
      width: 100%;
      .haier-inspection-body{
        .haier-list-page{
          margin-left: 0px;
        }
      }
      .planHidden{
        display: none;
      }
      .targetSigned_title_left_style{
        color:#1D2129;
        font-weight: 500;
        padding-right: 8px;
        font-size: 14px;
        margin-bottom: -10px;
      }
      .target_top_row1{
        margin-bottom: 8px;
      }
      .target_top_row2{
        margin-bottom: 8px;
        margin-top: 8px;
      }
      .target_top_left{
        color: #4E5969;
        font-size: 14px;
        line-height: 20px;
        display: block;
        float: left;
      }
      .target_top_right{
        color: #1D2129;
        font-size: 14px;
        line-height: 20px;
        display: block;
        float: left;
      }
    }
    .target_bottom_style{
      padding-top: 3px;
      width: 100%;
      min-height: 200px;
      background-color: #f2f4f7;
      .target_bottom_inner_style{
        width: 100%;
        margin-left: 10px;
        border-radius: 8px;
        background-color: #fff;
        min-height: 180px;
        .target_bottom_inner_title_style{
          padding-top: 12px;
          padding-bottom: 4px;
          line-height: 22px;
          padding-left: 16px;
          .targetSigned_left_style{
            color:#1D2129;
            font-weight: 500;
            padding-right: 8px;
            font-size: 14px;
          }
        }
        .targetSigned_body_style{
          font-size: 14px;
          line-height: 22px;
          color: #1D2129;
          padding-left: 16px;
          text-indent:24px;
          padding-bottom: 6px;
          .targetSigned_body_row_style{
            display: flex;
            justify-content: flex-start;
            min-height: 40px;
            line-height: 40px;
            padding: 3px 0;
            color: #666;
            .targetSigned_body_right_style{
              .el-textarea{
                width: 800px;
              }
              .el-input__inner{
                width: 800px;
              }
              .rainbow-file-upload{
                width: 800px;
                padding-left: 23px;
              }
              .el-select{
                padding-left: 23px;
              }
              .select-trigger{
                width: 800px;
                .el-input__inner{
                  width: 100%;
                }
                .el-input__suffix{
                  right: 0px;
                  top: 0px;
                  .el-input__icon{
                    line-height: 30px;
                  }
                  .el-select__caret.is-reverse{
                    -webkit-transform: rotateZ(180deg); 
                    transform: rotateZ(180deg);
                  }
                }
              }
            }
          }
        }
      }
    }
    </style>